
var content = require("!!../../../../mini-css-extract-plugin/dist/loader.js!../../../../css-loader/index.js??ref--0-2!../../../../sass-loader/lib/loader.js??ref--0-3!./classic.time.css");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = require("!../../../../style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(module.hot) {
	module.hot.accept("!!../../../../mini-css-extract-plugin/dist/loader.js!../../../../css-loader/index.js??ref--0-2!../../../../sass-loader/lib/loader.js??ref--0-3!./classic.time.css", function() {
		var newContent = require("!!../../../../mini-css-extract-plugin/dist/loader.js!../../../../css-loader/index.js??ref--0-2!../../../../sass-loader/lib/loader.js??ref--0-3!./classic.time.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}